import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
const useEventHomeStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const cardContainerHeightMobile = `${56 + 80}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            overflowY: 'hidden',
            height: '100%',
            px: isMobileIpadNavigation ? 0 : 0
        },
        contentContainer: {
            flexGrow: 1,
            overflowY: 'hidden',
            height: '100%'
        },
        titleStyle: {
            fontWeight: 500,
            mb: 2,
            color: (theme) => theme.palette.text.primary
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            height: '100%'
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        gridItem: {
            height: `calc(100dvh - 600px)`
        },
        container: {
            height: '100%',
            p: 2
        },
        gridContainer: {
            height: '100%'
        },
        activityFramesContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.75
        },
        cardSection: {
            backgroundColor: alpha('#25292D', 0.3),
            borderRadius: 4,
            backdropFilter: 'blur(10px)'
        }
    };
};
export default useEventHomeStyles;
